import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    },
  };

  return axios.get(`${url}/transaction-dpas`, options).then((response) => {
    return {
      list: jsona.deserialize(response.data),
      meta: response.data.meta,
    };
  });
}

function get(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(`${url}/transaction-dpas/${id}`, options)
    .then((response) => {
      let transaction = jsona.deserialize(response.data);
      delete transaction.links;
      return transaction;
    });
}

function add(transaction) {
  const payload = jsona.serialize({
    stuff: transaction,
    includeNames: null,
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.post(`${url}/transaction-dpas`, payload, options).then((response) => {
    return jsona.deserialize(response.data);
  });
}

function update(transaction) {
  const payload = jsona.serialize({
    stuff: transaction,
    includeNames: [],
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .patch(`${url}/transaction-dpas/${transaction.id}`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.delete(`${url}/transaction-dpas/${id}`, options);
}

function cancel(transaction) {
  const payload = jsona.serialize({
    stuff: transaction,
    includeNames: [],
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .patch(`${url}/transaction-dpas/${transaction.id}/cancel`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}


function validate(transaction) {
  console.log(transaction);
  const payload = jsona.serialize({
    stuff: transaction,
    includeNames: [],
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .patch(`${url}/transaction-dpas/${transaction.id}/validate`, payload, options)
    .then((response) => {
      let transaction = jsona.deserialize(response.data);
      delete transaction.links;
      return transaction;
    });
}


export default {
  list,
  get,
  add,
  update,
  destroy,
  cancel,
  validate,
};
